/**
 * Einblenden beim Scrollen.
 *
 * Jede Section meldet ihre Elemente mit dem Attribut data-reveal an. Sobald
 * eines davon weit genug im Bild ist, bekommt es die Klasse "is-revealed" –
 * den Rest macht das CSS in critical.css.
 *
 * Bewusst als Progressive Enhancement: Ohne JavaScript fehlt die Klasse "js"
 * am <html>-Element, der Ausgangszustand greift nicht und alles ist sichtbar.
 *
 * Warum ein gedrosselter Scroll-Zuhoerer und kein IntersectionObserver:
 * Der Observer meldet nur Zustandswechsel. Springt die Seite in einem Zug an
 * eine tiefere Stelle – per Sprungmarke, ueber die Scroll-Wiederherstellung
 * beim Neuladen oder mit einem schnellen Wisch –, wechseln die uebersprungenen
 * Elemente von "unterhalb, nicht sichtbar" zu "oberhalb, nicht sichtbar".
 * Fuer den Observer aendert sich dabei nichts, er meldet nie, und die
 * Elemente blieben dauerhaft unsichtbar. Genau das war im Test der Fall.
 *
 * Der Zuhoerer prueft deshalb beides: im Bild oder bereits vorbei. Er laeuft
 * hoechstens einmal je Bild, meldet sich passiv an und entfernt sich selbst,
 * sobald nichts mehr einzublenden ist.
 */
(function () {
  const REDUZIERT = window.matchMedia('(prefers-reduced-motion: reduce)');
  const offen = new Set();
  let angefordert = false;

  function einblenden(el) {
    el.classList.add('is-revealed');
    offen.delete(el);
  }

  function pruefen() {
    angefordert = false;
    const hoehe = window.innerHeight;

    offen.forEach((el) => {
      const kasten = el.getBoundingClientRect();
      // Weit genug im Bild – oder schon oben hinausgescrollt.
      if (kasten.top < hoehe * 0.88 || kasten.bottom < 0) einblenden(el);
    });

    if (offen.size === 0) abmelden();
  }

  function planen() {
    if (angefordert) return;
    angefordert = true;
    requestAnimationFrame(pruefen);
  }

  function abmelden() {
    window.removeEventListener('scroll', planen);
    window.removeEventListener('resize', planen);
  }

  function anmelden(bereich) {
    const ziele = (bereich || document).querySelectorAll('[data-reveal]:not(.is-revealed)');
    if (ziele.length === 0) return;

    // Wer Bewegung abbestellt hat, bekommt den Inhalt sofort und vollstaendig.
    if (REDUZIERT.matches) {
      ziele.forEach((el) => el.classList.add('is-revealed'));
      return;
    }

    ziele.forEach((el) => offen.add(el));
    window.addEventListener('scroll', planen, { passive: true });
    window.addEventListener('resize', planen, { passive: true });
    planen();
  }

  anmelden();

  // Bilder und Schriften verschieben das Layout noch nach dem Aufbau – danach
  // kann ein Element im Bild stehen, ohne dass jemand gescrollt hat.
  window.addEventListener('load', planen);

  // Im Theme-Editor wird eine Section beim Bearbeiten neu gerendert. Ohne
  // diese Zeile blieben die neuen Elemente unsichtbar liegen.
  document.addEventListener('shopify:section:load', (e) => anmelden(e.target));
})();
